import { ControlType, FetchStatus, Property } from "../../../../../base/types";
import { DateTimeProperties, useDateTimeProperties } from "./DateTimeProperties";
import { ErrorMessage, Spinner } from "../../../../../widgets";
import { FC, useCallback } from "react";

import { DateTimeField } from "./DateTimeField";
import { DraftDateTimeComponent } from "./DraftDateTimeComponent";
import { IControlAttributes } from "../../../../../base/models";
import { InputLabel } from "../../InputLabel";
import { Registry } from "../../../../../base/register";
import { SimpleDateTime } from "./SimpleDateTime";

export const DateTimeComponent: FC<IControlAttributes> = ({
    control, className, props
}) => {
    const { status, properties, bindings, error } = useDateTimeProperties(props);
    const { label, required, title } = properties || {}
    const containerClass = label ? className : ''
    const inputClass = label ? '' : className

    const getDateTimeNode = useCallback(() => {
        const binding = bindings?.getBinding(Property.InitValue);
        switch (binding?.type) {
            case "Field":
                return <DateTimeField
                    id={control.controlId}
                    title={title}
                    name={binding.boundValue}
                    {...properties}
                    className={inputClass}
                />
            case "Const":
            case "Expression":
            default:
                return <SimpleDateTime
                    id={control.controlId}
                    title={title}
                    {...properties}
                    value={binding?.value}
                    className={inputClass}
                />
        }

        // eslint-disable-next-line
    }, [properties, bindings, control])


    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <InputLabel
        htmlFor={control.controlId}
        title={title}
        label={label}
        required={required}
        className={containerClass}>
        {getDateTimeNode()}
    </InputLabel>
}

Registry.addControl({
    id: "d65d1b0b-1804-4b40-b3e1-17df59182121",
    name: "DateTime Input",
    type: ControlType.DateTime,
    properties: DateTimeProperties,
    component: DateTimeComponent,
    draftComponent: DraftDateTimeComponent
})
